import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '@/layouts';
import Login from '@/pages/login';
import Dashboard from '@/pages/dashboard';
import SystemUsers from '@/pages/system/users';
import BusinessUsers from '@/pages/business/users';
import Permissions from '@/pages/business/permissions';
import AuditLogs from '@/pages/audit-logs';
import { useAuthStore } from '@/stores/auth';

const Router = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {isAuthenticated ? (
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="system/users" element={<SystemUsers />} />
          <Route path="business/users" element={<BusinessUsers />} />
          <Route path="business/permissions" element={<Permissions />} />
          <Route path="audit-logs" element={<AuditLogs />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
};

export default Router; 